import { SafeAreaView } from "react-native";
import Lottie from "lottie-react-native";
import robozinho from "./robozinho.json";
import "../css/HomeCss.css";


function Home(){
  return(
    <div className="paiHome">
      <div className="titulo">
        <h1 className="animated-div">
          A questão não é saber os códigos ou linhas de comando, é saber o que
          você precisa!
        </h1>
        ⁠<h3 className="t2">Produtos digitais ?, Landing pages?.</h3>
        <h3 className="animated-div">
          Olá, me chamo Romenson, atualmente trabalho e estudo na área de
          desenvolvimento web.
        </h3>
        <div className="botoesCtn"></div>
        <br />
        <br />
        <button className="glow-on-hover">Instagram</button>

      </div>
      <div>
        <SafeAreaView
          style={{
            marginTop: "",
            flex: 1,
            justifyContent: "center",
            width: "23em",
            height: "",
            alignContent: "center",
          }}
        >
          <Lottie
            resizeMode="contain"
            autoSize
            source={robozinho}
            autoPlay
            loop
          />{" "}
        </SafeAreaView>
      </div>
      
    </div>
  );

        }
export default Home;
